import { put } from "redux-saga/effects";
import { NOTIFICATION_ALERT } from "../constants/constants";

export function* setNotificationAlertMsgFunc(data) {
  if (data.payload.notificationAlert) {
    yield put({
      type: NOTIFICATION_ALERT,
      payload: data.payload.notificationAlert,
    });
  }
}

export function setNotificationAlert(data) {
  return {
    type: NOTIFICATION_ALERT,
    payload: data,
  };
}
